import React from 'react';

const maxLength = 26;

export const keepMaxLength = (event: React.ChangeEvent<HTMLInputElement>) => {
  if (event.target.value.length > maxLength) {
    event.target.value = event.target.value.slice(0, maxLength);
  }
};
